/**
 * Docebo AdditionalField model
 */
export class AdditionalField {
  constructor(
    public id: number,
    public title: string,
    public type: string,
    public value: string,
    public visibleToUser?: boolean // Optional Field
  ) {}
}
